var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.75H5C4.58579 3.75 4.25 4.08579 4.25 4.5V10.5C4.25 10.9142 4.58579 11.25 5 11.25H11C11.4142 11.25 11.75 10.9142 11.75 10.5V4.5C11.75 4.08579 11.4142 3.75 11 3.75Z",
    fill: "#1A1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75H14C13.5858 3.75 13.25 4.08579 13.25 4.5V10.5C13.25 10.9142 13.5858 11.25 14 11.25H20C20.4142 11.25 20.75 10.9142 20.75 10.5V4.5C20.75 4.08579 20.4142 3.75 20 3.75Z",
    fill: "#1A1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.75H5C4.58579 12.75 4.25 13.0858 4.25 13.5V19.5C4.25 19.9142 4.58579 20.25 5 20.25H11C11.4142 20.25 11.75 19.9142 11.75 19.5V13.5C11.75 13.0858 11.4142 12.75 11 12.75Z",
    fill: "#1A1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.75H14C13.5858 12.75 13.25 13.0858 13.25 13.5V19.5C13.25 19.9142 13.5858 20.25 14 20.25H20C20.4142 20.25 20.75 19.9142 20.75 19.5V13.5C20.75 13.0858 20.4142 12.75 20 12.75Z",
    fill: "#1A1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.8a2f9457911f357808698a449c02596c.svg";
export { ForwardRef as ReactComponent };